import ApiMigration from "../../../../contents/docs/migrate/_snippets/api-migration.mdx";
import * as React from 'react';
export default {
  ApiMigration,
  React
};